import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import BreakingBar from "./components/BreakingBar";
import Hero from "./components/Hero";
import LatestFeed from "./components/LatestFeed";
import Featured from "./components/Featured";
import Timeline from "./components/Timeline";
import Faq from "./components/Faq";
import About from "./components/About";
import SubmitForm from "./components/SubmitForm";
import Footer from "./components/Footer";

const orgSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "大瓜预警",
      alternateName: "BIG MELON ALERT",
      url: "https://ompi.cn/",
      email: "hello@daguayujing.cn",
      description:
        "大瓜预警汇集内部消息与知情人士透露，提供圈内人爆料的分类资讯与匿名投稿通道，强调理性吃瓜、不造谣不传谣。",
    },
    {
      "@type": "WebSite",
      name: "大瓜预警",
      url: "https://ompi.cn/",
      inLanguage: "zh-CN",
    },
  ],
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 800);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="w-full bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <BreakingBar />
      <main className="w-full">
        <Hero />
        <LatestFeed />
        <Featured />
        <Timeline />
        <Faq />
        <About />
        <SubmitForm />
      </main>
      <Footer />

      <button
        type="button"
        aria-label="返回顶部"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-lg" />
      </button>
    </div>
  );
}